export default "__VITE_ASSET__DOFUH4ur__"